import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from "react-redux";
import { Modal } from "bootstrap";
import { toast } from 'react-toastify';
import HttpAPICall from "../../../services/HttpAPICall";
import Loader from "../../../components/ui/Loader/Loader";
import tapIcon from "../../../services/TapIcon";
import TapSelect from '../../../components/ui/TapSelect';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import swal from 'sweetalert';

const ExpenseHead = () => {
    const accessToken = useSelector(state => state.auth.access_token);

    const initAddForm = {
        expense_head: "",
    };

    const [listLoading, setListLoading] = useState(false);
    const [listingData, setListingData] = useState([]);
    const [saveFormSubmitting, setSaveFormSubmitting] = useState(false);
    const [edit, setEdit] = useState(false);
    const [addExpenseHeadForm, setAddExpenseHeadForm] = useState({ ...initAddForm });
    const [userSites, setUserSites] = useState([]);
    const [expenseHeadModal, setExpenseHeadModal] = useState(null);

    useEffect(() => {
        if (document.getElementById('expenseHeadAddModal')) {
            const modal = new Modal(document.getElementById('expenseHeadAddModal'), {
                keyboard: false,
                backdrop: false
            });
            setExpenseHeadModal(modal);
        }
        getExpenseHeadListing();
    }, []);

    const getExpenseHeadListing = async () => {
        setListLoading(true);
        try {
            await HttpAPICall.withAthorization(
                'GET',
                IAM_API_BASE_URL_2 + '/expense/head_list',
                accessToken, {}, {},  (resp) => {
                    setListingData(resp.data.data || []);
                }
            );
        } catch (err) {
            console.error(err);
            setListingData([]);
        } finally {
            setListLoading(false);
        }
    };

    const expenseModalInit = (id = null, editMode = false) => {
        expenseHeadModal?.show();
        if (id && editMode) {
            const expenseData = listingData.find(i => i.id === id);
            if (expenseData) {
                setAddExpenseHeadForm({
                    id: expenseData.id,
                    expense_head: expenseData.expense_head || '',
                });
                setEdit(true);
            }
        } else {
            setEdit(false);
            setAddExpenseHeadForm({ ...initAddForm });
        }
    };

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setAddExpenseHeadForm({
            ...addExpenseHeadForm,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaveFormSubmitting(true);

        try {
            const url = edit
                ? IAM_API_BASE_URL_2 + '/expense/head_edit'
                : IAM_API_BASE_URL_2 + '/expense/head_add';

            const method = edit ? 'PUT' : 'POST';

            // Prepare payload based on edit mode
            let payload = {};
            if (edit) {
                // For edit: send both id and expense_head
                payload = {
                    id: addExpenseHeadForm.id,
                    expense_head: addExpenseHeadForm.expense_head
                };
            } else {
                // For add: send only expense_head
                payload = {
                    expense_head: addExpenseHeadForm.expense_head
                };
            }

            await HttpAPICall.withAthorization(
                method,
                url,
                accessToken,
                null,
                payload,
                (response) => {
                    toast.success(response.data.msg, {
                        position: toast.POSITION.TOP_RIGHT
                    });

                    expenseHeadModal?.hide();
                    getExpenseHeadListing();
                    setAddExpenseHeadForm({ ...initAddForm });
                }
            );
        } catch (err) {
            console.error(err);

            toast.error(
                err?.response?.data?.msg || "Something went wrong",
                { position: toast.POSITION.TOP_RIGHT }
            );
        } finally {
            setSaveFormSubmitting(false);
        }
    };

    return (
        <section className="container-fluid" style={{ padding: "0px 12px" }}>
            <div className="row bg-white p-2">
                <div className="col-sm-12">
                    <div className="tab_content_wrapper mt-2">
                        <span className="content_heading">Expense Head</span>
                        <div className="text-end">
                            <button className="btn btn-primary" onClick={() => expenseModalInit()}>
                                Add
                            </button>
                        </div>
                    </div>
                    <div className="page_containt">
                        <div className='pageTbl' style={{ height: "90%" }}>
                            <table className="table table-hover table-bordered my-4 table-sm">
                                <thead className="table-secondary">
                                    <tr className="text-center">
                                        <th scope="col" style={{ width: "10%" }}>S.No</th>
                                        <th scope="col" className="text-start" style={{ width: "70%" }}>Expense Head</th>
                                        <th scope="col" style={{ width: "20%" }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listLoading ? (
                                        <tr><td colSpan="3"><Loader /></td></tr>
                                    ) : (
                                        listingData && listingData.length > 0 ? (
                                            listingData.map((eh, k) => {
                                                // Check if record can be edited (master_id should NOT be null)
                                                const canEdit = eh.master_id !== null;
                                                
                                                return (
                                                    <tr key={k} className="text-center">
                                                        <td>{k + 1}</td>
                                                        <td className="text-start">{eh.expense_head || "-"}</td>
                                                        <td>
                                                            <span className="dropdown">
                                                                <button
                                                                    type="button"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                    className="btn"
                                                                >
                                                                    <tapIcon.FontAwesomeIcon icon={tapIcon.faEllipsisV} />
                                                                </button>
                                                                <ul className="dropdown-menu">
                                                                    <li>
                                                                        {canEdit ? (
                                                                            <a 
                                                                                className="dropdown-item" 
                                                                                role="button" 
                                                                                onClick={() => expenseModalInit(eh.id, true)}
                                                                            >
                                                                                Edit
                                                                            </a>
                                                                        ) : (
                                                                            <span 
                                                                                className="dropdown-item text-muted" 
                                                                                style={{ cursor: 'not-allowed' }}
                                                                            >
                                                                                Edit
                                                                            </span>
                                                                        )}
                                                                    </li>
                                                                </ul>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr><td colSpan="3" className="text-center">No Records</td></tr>
                                        )
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal */}
            <div className="modal fade" id="expenseHeadAddModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{edit ? "Edit" : "Add"} Expense Head</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="modal-body">
                                <div className="row my-3 align-items-center">
                                    <label className="col-sm-3 col-form-label">Expense Head Name</label>
                                    <div className="col-sm-9">
                                        <input
                                            name="expense_head"
                                            type="text"
                                            value={addExpenseHeadForm.expense_head}
                                            className="form-control"
                                            autoComplete="off"
                                            onChange={handleFormChange}
                                            placeholder="Please enter Expense Head Name"
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                    disabled={saveFormSubmitting}
                                >
                                    Close
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={saveFormSubmitting}
                                >
                                    Save {saveFormSubmitting && <tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ExpenseHead;